const queryHelper = {};
let searchParams = null;
let hasParsedInitialQuery = false;

function parseInitialQuery() {
  if (typeof window === 'undefined') {
    return;
  }

  searchParams = new URLSearchParams(window.location.search);
  hasParsedInitialQuery = true;
}

queryHelper.updateQueryWithValues = (kvp) => {
  if (!hasParsedInitialQuery) {
    parseInitialQuery();
  }

  Object.keys(kvp).forEach((key) => {
    const value = kvp[key];
    const isTruthy = !!value; // Not null, undefined, empty string, etc.
    if (isTruthy) {
      searchParams.set(key, kvp[key]);
    } else {
      searchParams.delete(key);
    }
  });

  if (typeof history !== 'undefined' && history.replaceState) {
    history.replaceState({}, '', decodeURIComponent(`${window.location.pathname}?${searchParams}`));
  }
};

queryHelper.getQueryKeyValue = (key) => {
  if (!hasParsedInitialQuery) {
    parseInitialQuery();
  }

  const values = searchParams.getAll(key);
  if (!values?.length) {
    return '';
  }
  if (values?.length === 1) {
    return values[0];
  }
  return values;
};

queryHelper.getQueryKeyValues = (keys = []) => {
  return keys.map(queryHelper.getQueryKeyValue);
};

queryHelper.getAllQueryParamsEntries = () => {
  if (!hasParsedInitialQuery) {
    parseInitialQuery();
  }

  return Array.from(searchParams.entries());
};

export default queryHelper;
